module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/kv_bg_sp_2-148bb0d48ee37919d8cd5c826eb65eda.jpg";